export class ReversalTransaction {
    constructor(
    public Application_ReferenceNumber: number,
    public Application_TransactionType: string) {}
}



// WEBPACK FOOTER //
// ./src/app/models/reversalTransaction.model.ts